import { useEffect, useState } from "react";
import axios from "axios";

/**
 * Custom hook for fetching sessions information.
 * @returns An object containing the fetched data, loading state, and a function to fetch sessions information.
 */
const useDeleteSession = () => {
    const [data, setData] = useState<any>({});
    const [loading, setLoading] = useState(false);

    const API_URL = process.env.REACT_APP_DELETE_SESSION || ""
    const api_key = process.env.REACT_APP_API_KEY || ""
    /**
     * Fetches sessions information using the provided request object.
     * @param requestObject - The request object containing the necessary parameters for fetching sessions information.
     */
    const deleteSession = async (requestObject: any) => {
        try {
            setLoading(true);
            const responseFetch = await fetch(API_URL, {
                method: "DELETE",
                headers: {
                  "Content-Type": "application/json",
                  "x-api-key": api_key
                },
                body: JSON.stringify(requestObject),
              });
              const response = await responseFetch.json();
            setData(response);
        } catch (error) {
            setData(null);
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    return { data, loading, deleteSession };
};

export default useDeleteSession;